module.exports = __webpack_public_path__ + "img/customize_want.ed2e85c8.svg";